import * as React from "react";
import { Helmet } from "react-helmet";
import { fetchData, postQuery, uploadFile } from '../utils'
import * as AuthStore from "../store/Auth";
import { ApplicationState } from '../store';
import * as Highcharts from 'highcharts';
import { connect } from "react-redux";
import { Table, Button, Select, Upload, message, Card, Form, Row, Col, Modal, Input, Switch } from 'antd';
import { InboxOutlined, CloseCircleOutlined, SearchOutlined, EditFilled, PlusCircleOutlined } from '@ant-design/icons';
import { busyGif } from '../img';
const { Option } = Select;
const { Item } = Form;
const { Dragger } = Upload;

type AuthProps =
    AuthStore.AuthState // ... state we've requested from the Redux store
    & typeof AuthStore.actionCreators // ... plus action creators we've requested

class Provider extends React.Component<AuthProps>
{
    public state =
    {
        buttonText: 'Add',
        data: [],
        pagination:
        {
            current: 1,
            total: 0,
            pageSize: 10,
            sorter: {
                field: "name",
                order: "asc"
            }
        },
        loading: false,
            confirmLoading: false,
            fLoading: false,
        title: 'New Service Provider',
            provider: { id: '', stateId: '', serviceProviderFacilities: [], status: 1, userId: '' },
        searchText: "",
            visible: false,
            states: [],
            jollyUsers: [],
        hideUpload: false,
            showDetails: false,
            statesLoaded: true,
            facilities: [],            
            state: { stateId: 0, stateName: '', stateCode: '', sites: [], jollyUsers: [] },
    };
    async componentDidMount()
    {
        const { pagination } = this.state;
        let el = this;
        let sts = localStorage.getItem("states");
        let states = [];
        if (sts) states = JSON.parse(sts);       
        this.setState({ states });
        
        this.getItems({
            results: pagination.pageSize,
            searchText: this.state.searchText,
            page: pagination.current,
            sortField: pagination.sorter.field,
            sortOrder: pagination.sorter.order
        });

        var query = `/api/Jolly95/getJollyUsers`;
        let res = await fetchData(query);
        if (res.length > 0)
        {
            res.map(s =>
            {
                var ss = states.filter(f => f.stateCode === s.stateCode);
                if (ss.length > 0)
                {
                    s.name = ss[0].stateName;
                    s.stateId = ss[0].stateId;
                    s.sites = ss[0].sites;
                }
            });
            let statesLoaded = true;
            el.setState({ jollyUsers: res, statesLoaded });
        }
    }
    handleTableChange(pagination: any, filters: any, sorter: any)
    {
        const pager = this.state.pagination;
        pager.current = pagination.current;

        this.setState({
            pagination: pager
        });
        this.getItems({
            results: pager.pageSize,
            searchText: this.state.searchText,
            page: pager.current,
            sortField: pager.sorter.field,
            sortOrder: pager.sorter.order
        });
    }  
    async getItems(params: any)
    {
        this.setState({ loading: true });
        var searchText = params.searchText;
        var results = params.results;
        var page = params.page;
        let el = this;

        var query = `/api/Jolly95/getServiceProviders?itemsPerPage=${results}&pageNumber=${page}&searchText=${searchText}`;

        let res = await fetchData(query);
        console.log(res.serviceProviders);
        const { pagination } = el.state;
            pagination.total = res.totalItems;           
            el.setState({
                data: res.serviceProviders,
                pagination,
                loading: false 
            });                      

        if (searchText && searchText.trim().length > 0)
        {
            const reg = new RegExp(searchText, 'gi');
            this.setState({
                filtered: !!searchText,
                data: this.state.data.map((record: any) =>
                {
                    const match = record.name.toString().match(reg);

                    if (!match)
                    {
                        return null;
                    }
                    return {
                        ...record,
                        name: (<span> {record.name.split(reg).map((text: any, i: any) => (i > 0 ? [<span key={record.id} className="highlight">{match[0]}</span>, text] : text
                        ))}
                        </span>
                        )
                    };
                }).filter(record => !!record)
            });
        }
    }
    handleChange(value: any)
    {
        const { pagination } = this.state;
        pagination.pageSize = parseInt(value);

        this.setState({
            pagination: pagination
        });

        this.getItems({
            results: pagination.pageSize,
            searchText: this.state.searchText,
            page: pagination.current
        });
    }
    onInputChange(e: any)
    {
        let searchTerm = e.target.value.trim();
        this.setState({searchText: searchTerm});       
    }
    selectSite(value: any)
    {
        let el = this;
        var { provider, facilities } = this.state;
        if (value || value.length > 0)
        {
            let sites: any = []
            value.map(i => {
                var st = el.state.state.sites.filter(function (o: any) { return o.id === i; });
                if (st.length > 0) {
                    sites.push(st[0]);
                }
            });

            if (sites.length > 0)
            {
                provider.serviceProviderFacilities = [];
                facilities = [];
                sites.map(s => {
                    provider.serviceProviderFacilities.push({ id: 0, facilityId: s.id, serviceProviderId: 0, facilityCoverageStatus: 1});
                    facilities.push(s.id);
                    this.setState({ provider, facilities });
                });
            }
            else 
            {
                provider.serviceProviderFacilities = [];
                facilities = [];
                this.setState({ provider, facilities });
            }
        }
        else
        {
            provider.serviceProviderFacilities = [];
            facilities = [];
            this.setState({ provider, facilities });
        }
    }
    selectState(value: any)
    {
        if (!value)
        {
            return;
        }
        var el = this;
        const { provider } = el.state;       
        if (value)
        {
            let val = value.key;
            let states = el.state.jollyUsers.filter(function (s: any) { return s.stateId === val });
            if (states.length > 0)
            {
                var state = states[0];
                provider.stateId = state.stateId;
                el.setState({ state: state, provider: provider });
            }
        }
    }
    selectUser(value: any)
    {
        if (!value)
        {
            return;
        }
        const { provider } = this.state;
        if (value)
        {
            let val = value.key;
            provider.userId = val;
            this.setState({ provider: provider });
        }
    }
    onSearch()
    {
        let el = this;
        const { pagination } = el.state;
        if (!el.state.searchText || el.state.searchText.length < 1)
        {
            message.error('Please provide a search entry');
            return;
        }
        this.getItems({
            results: pagination.pageSize,
            searchText: el.state.searchText,
            page: pagination.current
        });
    }
    edit(data: any, row: any)
    {
        var { facilities, state } = this.state;

        let states = this.state.states.filter(function (s: any) { return s.stateId === data.stateId });
        if (states.length > 0)
        {
            state = states[0];
        }
        facilities = [];
        if (data.serviceProviderFacilities || data.serviceProviderFacilities.length > 0)
        {
            data.serviceProviderFacilities.map(i =>
            {
                if (i.facilityCoverageStatus > 0)
                    facilities.push(i.facilityId);
            });
        }
        this.setState({ visible: true, title: 'Update Service Provider', buttonText: 'Update', provider: data, facilities, state });
    }
    Add()
    {
      this.setState({ visible: true, title: 'Add Service Provider', buttonText: 'Add', provider: { id: '', stateId: '', serviceProviderFacilities: [], status: 1, userId: '' }});
    }

    fileControlClicked()
    {
        var ecl = document.getElementById("txSel");
        if (ecl)
            ecl.click();
    }

    dwnTemplate()
    {
        //@ts-ignore
        window.location = "/templates/facilites.xlsx";
    }

    startUpload()
    {
        this.setState({hideUpload: true});
    }

    async process()
    {
        let el = this;
        if (el.state.provider.userId.length < 1)
        {
            message.error("Please select a User");
            return;
        }
        if (el.state.provider.serviceProviderFacilities.length < 1)
        {
            message.error("Please select atleast a Facility");
            return;
        }
        if (!el.state.provider.stateId)
        {
            message.error('Select a State');
            return;
        }
        if (el.state.provider.serviceProviderFacilities.length < 1)
        {
            message.error('Please map Service Provider to at least one Facility');
            return;
        }
        let url = '';
        let payload = {};
        // @ts-ignore
        if (!el.state.provider.id || el.state.provider.id.length < 1) 
        {
            url = '/api/Jolly95/addServiceProvider';
            payload = { stateId: el.state.provider.stateId, userId: el.state.provider.userId, serviceProviderFacilities: el.state.provider.serviceProviderFacilities, status: el.state.provider.status };
        }
        else
        {
            url = '/api/Jolly95/updateServiceProvider';
            // @ts-ignore
            payload = { id: el.state.provider.id, stateId: el.state.provider.stateId, userId: el.state.provider.userId, serviceProviderFacilities: el.state.provider.serviceProviderFacilities, status: el.state.provider.status };
        }

        const { pagination } = el.state;
        let params =
        {
            results: pagination.pageSize,
            searchText: el.state.searchText,
            page: pagination.current
        };

        el.setState({ confirmLoading: true });
        let res = await postQuery(url, JSON.stringify(payload));
        el.setState({ confirmLoading: false });
        if (res.code > 0)
        {
            el.getItems(params);
            el.setState({ visible: false });
            message.success(res.message);
        }
        else
        {
            message.error(res.message);
        }
    }
        
    exit() {
        this.setState({
            visible: false, hideUpload: false
        });
    }
    
    textChange(feture: any, e: any)
    {
        let provider = this.state.provider;        
        provider[feture] = e.target.value;
        this.setState({ provider });
    }

    async upload(file: any)
    {
        //let file = e.target.files[0];
        let form = new FormData();
        form.append('file', file);
        form.append('fileName', file.name);
        console.log(form);
        this.setState({ confirmLoading: true });
        let res = await uploadFile('/api/Site/uploadSites', form);
        this.setState({ confirmLoading: false });

        if (res.code < 1)
        {
            message.error(res.message);
        }
        else
        {
            message.success(res.message);
            const { pagination } = this.state;
            this.setState({ hideUpload: false });
            this.getItems({
                results: pagination.pageSize,
                searchText: this.state.searchText,
                page: pagination.current,
                sortField: pagination.sorter.field,
                sortOrder: pagination.sorter.order
            });
        }
    }

    closeView()
    {
        this.setState({ showDetails: false });
    }

    setChecked(checked)
    {
        const { provider } = this.state;
        provider.status = checked === true ? 1 : 0;
        this.setState({ provider });
    }

    render()
    {
        const { title, jollyUsers, state, facilities, confirmLoading, visible, showDetails, provider, searchText, buttonText } = this.state;
        let el = this;
        const user = this.props.appUser;
        
        const columns =
            [
                {
                    title: 'First Name',
                    dataIndex: 'firstName',
                    key: 'firstName',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value}</span>
                },
                {
                    title: 'Last Name',
                    dataIndex: 'lastName',
                    key: 'lastName',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value}</span>
                },
                {
                    title: 'Phone Number',
                    dataIndex: 'phoneNumber',
                    key: 'phoneNumber',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value}</span>
                },
                {
                    title: 'State',
                    dataIndex: 'stateName',
                    key: 'stateName',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value}</span>
                },
                {
                    title: 'Facilities Covered',
                    dataIndex: 'facilities',
                    key: 'facilities',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value}</span>
                },                ,
                {
                    title: 'Edit',
                    dataIndex: '', key: 'x',
                    render: (value, row, index) => <EditFilled onClick={() => this.edit(value, row)} key={value.id} style={{ cursor: 'pointer' }} />
                }
            ]; 
        return (
            <div style={{ marginTop: '15px', padding: '20px' }}>
                <Helmet>
                    <title>CDR - Manage Service Providers</title>
                </Helmet>                
                <div className="custom-filter-dropdown" style={{ display: showDetails ? 'none' : 'block' }}>
                    <Row style={{ marginTop: '2px' }}>
                        <Col span={24}>
                            <h4 style={{ fontWeight: 'bold', fontSize: '18px' }}>Manage Service Providers</h4>
                        </Col>
                    </Row>
                    <Row gutter={2}>
                        <Col xs={24} sm={24} md={3} lg={3}>
                            <Select className="top-10-margin" defaultValue="10" id="pageSize" onChange={(v) => this.handleChange(v)}>
                                <Option value="10">10</Option>
                                <Option value="25">25</Option>
                                <Option value="50">50</Option>
                                <Option value="100">100</Option>
                            </Select>
                        </Col>
                        <Col xs={24} sm={24} md={6} lg={6}>
                            <Input className="ant-input-lg-2 top-10-margin" style={{ width: '100%' }} placeholder="Search by name or State code..." value={searchText} onChange={(s) => el.onInputChange(s)} onPressEnter={() => el.onSearch()} />                                                       
                        </Col>
                        <Col xs={24} sm={24} md={15} lg={15}>
                            <Button disabled={confirmLoading} className="login-button top-10-margin" id="push-btn" key="submit" size="large" onClick={() => this.Add()} style={{ float: 'right', marginRight: '25px', width: '20%' }} icon={<PlusCircleOutlined />}>
                                <span id="buttonText">New Provider</span>
                            </Button>
                        </Col>
                    </Row>
                    <br />
                    <Row gutter={2}>
                        <Col span={24} style={{overflow: "scroll"}}>
                            <Table columns={columns} rowKey={record => record.id} dataSource={this.state.data} pagination={this.state.pagination} loading={this.state.loading} onChange={(a: any, b: any, c: any) => this.handleTableChange(a, b, c)} bordered />
                        </Col>
                    </Row>
                </div>

                <div className="md-wrapper">
                    <Modal className="modal-width-500"
                        visible={visible}
                        title={title}
                        maskClosable={false}
                        onCancel={() => this.exit()}
                        footer={[
                            <Button loading={confirmLoading} disabled={confirmLoading} style={{ width: '27%' }}  className="login-button" key="submit" type="primary" size="large" onClick={() => this.process()}>
                                <span id="buttonText">{buttonText}</span>
                            </Button>
                        ]}>
                        <Form>
                            <div className='ant-row'>                                
                                <div className='ant-col-24 padding-md'>
                                    <Item>
                                        <Select className="circl-radius"
                                            labelInValue
                                            showSearch
                                            optionFilterProp="children"
                                            disabled={confirmLoading}
                                            //@ts-ignore
                                            value={{ key: provider.stateId }}
                                            style={{ width: '100%' }}
                                            placeholder="-- Select State --"
                                            onChange={(value) => this.selectState(value)}
                                        >
                                            <Option key='' value=''>-- Select State --</Option>
                                            {jollyUsers && jollyUsers.map((s: any) => <Option key={s.stateId} value={s.stateId}>{s.name}</Option>)}
                                        </Select>
                                    </Item>
                                </div>
                                <div className='ant-col-24 padding-md'>
                                    <Item>
                                        <Select className="circl-radius"
                                            labelInValue
                                            showSearch
                                            optionFilterProp="children"
                                            disabled={confirmLoading}
                                            style={{ width: '99%', float: 'right' }}
                                            //@ts-ignore
                                            value={{ key: provider.userId }}
                                            placeholder="Select Service Provider"
                                            onChange={(value) => this.selectUser(value)}>
                                            <Option key='' value=''>-- Select Service Provider --</Option>
                                            {state.jollyUsers && state.jollyUsers.map((s: any) => <Option key={s.id} value={s.id}>{s.fullName}</Option>)}
                                        </Select>
                                    </Item>
                                </div>
                                <div className='ant-col-24 padding-md'>
                                    <Item>
                                        <Select className="circl-radius"
                                            mode="multiple"  
                                            showSearch
                                            optionFilterProp="children"
                                            disabled={confirmLoading}
                                            style={{ width: '99%', float: 'right' }}                                            
                                            //@ts-ignore
                                            value={facilities}
                                            placeholder="Select Site (s)"
                                            onChange={(value) => this.selectSite(value)}
                                        >
                                            <Option key='' value=''>-- Select Site (s) --</Option>
                                            {state.sites && state.sites.map((s: any) => <Option key={s.id} value={s.id}>{s.name}</Option>)}
                                        </Select>
                                    </Item>
                                </div>
                                <div className='ant-col-24 padding-md'>
                                    <Item>
                                        <label>Provider Status: </label> &nbsp;<Switch checked={provider.status === 1? true :  false} onChange={(checked) => this.setChecked(checked)} />
                                    </Item>
                                </div>
                            </div>
                        </Form>
                    </Modal>
                </div>
            </div>
        )
    }
}

export default connect(
    (state: ApplicationState) => state.auth, // Selects which state properties are merged into the component's props
    AuthStore.actionCreators // Selects which action creators are merged into the component's props
)(Provider as any);
